import { userStore } from "../store/userStore"
import { requestFcmToken } from "./webPush"

type RequestResult<T> = { status: "success"; data: T } | { status: "error"; error: { message: string } }

type RequestData = <T>(opts: {
    type: "GET" | "POST" | "PUT" | "DELETE" | "PATCH"
    path: string
    sendData?: Record<string, any>
    disableError?: boolean
    disableVersion?: boolean
}) => Promise<RequestResult<T>>

/**
 * Вызывать только из пользовательского действия (кнопка/клик).
 * Сохраняет токен в `userStore.deviceToken`, после чего он начнёт улетать
 * на бэкенд в заголовке `X-FCM-Token` во всех запросах.
 */
export async function enablePushNotifications(requestData: RequestData): Promise<string | null> {
    const token = await requestFcmToken()
    if (token) {
        userStore.getState().setDeviceToken(token)
        // Как в мобильных приложениях: регистрируем токен на бэке
        requestData({
            type: "POST",
            path: "token",
            sendData: { token },
            disableError: true,
        }).catch(() => {})
    }
    return token
}

